/* OKEN: zentrale Add-to-cart-Funktion mit optionalem Ausschenker.
   Keine Warenkorb-Aktion beim Laden der Datei. */
(() => {
  'use strict';

  // Aufrufe innerhalb dieses Browser-Tabs nacheinander verarbeiten.
  let queue = Promise.resolve();

  const root = () => window.Shopify?.routes?.root || '/';
  const endpoint = (path) => `${root()}cart${path ? '/' + path : ''}.js`;

  async function requestJson(url, options) {
    const response = await fetch(url, {
      credentials: 'same-origin',
      ...options
    });
    if (!response.ok) {
      let detail = '';
      try {
        const body = await response.json();
        detail = body.description || body.message || '';
      } catch (_) { /* Keine lesbare JSON-Fehlermeldung. */ }
      throw new Error(detail || `Shopify Cart API: HTTP ${response.status}`);
    }
    return response.json();
  }

  async function addProductInternal({ variantId, quantity = 1, ausschenkerGratis = false }) {
    const id = Number(variantId);
    const qty = Number(quantity);
    if (!Number.isSafeInteger(id) || id <= 0) {
      throw new TypeError('Ungültige Varianten-ID.');
    }
    if (!Number.isSafeInteger(qty) || qty < 1) {
      throw new TypeError('Ungültige Menge.');
    }
    if (typeof ausschenkerGratis !== 'boolean') {
      throw new TypeError('ausschenkerGratis muss true oder false sein.');
    }

    const items = [{ id, quantity: qty }];
    if (ausschenkerGratis) {
      const pourerId = Number(window.OKENAusschenkerConfig?.variantId);
      if (!Number.isSafeInteger(pourerId) || pourerId <= 0) {
        throw new Error('Ausschenker-Variante ist nicht konfiguriert.');
      }
      const cart = await requestJson(endpoint(''));
      const hasPourer = cart.items.some((item) => Number(item.variant_id) === pourerId);
      if (!hasPourer && id !== pourerId) {
        items.push({ id: pourerId, quantity: 1 });
      }
    }

    return requestJson(endpoint('add'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items })
    });
  }

  window.OKENAusschenker = Object.freeze({
    addProduct(options) {
      const task = queue.then(() => addProductInternal(options));
      // Die Warteschlange bleibt auch nach einem fehlgeschlagenen Aufruf verwendbar.
      queue = task.catch(() => {});
      return task;
    }
  });
})();
